import React, { useContext } from 'react';
import { Menu, Container, Button, Dropdown, Image } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { Link, NavLink } from 'react-router-dom';
import { RootStoreContext } from '../../app/stores/rootStore';

const NavBarDaily: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { user, logout } = rootStore.userStore;
  return (
    <Menu fixed="top" inverted style={{ marginLeft: '12%' }}>
         <Menu.Item as={NavLink} to='/dailymanagement/asset'>Asset</Menu.Item>
         <Menu.Item as={NavLink} to='/dailymanagement/warehouse'>Warehouse</Menu.Item>
        {/* <Dropdown item text='Warehouse'>
        <Dropdown.Menu>
        <Dropdown.Item as={NavLink} to='/dailymanagement/warehouse' text='Check Warehouse' icon='edit'/>
         <Dropdown.Item as={NavLink} to='/dailymanagement/warehouse-create' text='Add Warehouse Item' icon='write'/>
        </Dropdown.Menu>
        </Dropdown> */}
        <Menu.Item as={NavLink} to='/dailymanagement/third'>Third Party</Menu.Item>
        <Menu.Item as={NavLink} to='/dailymanagement/sorlist'>SOR</Menu.Item>
        <Menu.Item as={NavLink} to='/dailymanagement/photorequest'>Photo Request</Menu.Item>
        {/* <Dropdown item text='SOR'>
        <Dropdown.Menu>
         <Dropdown.Item as={NavLink} to='/dailymanagement/sorlist' text='Query SOR' icon='edit'/>
         <Dropdown.Item as={NavLink} to='/dailymanagement/sorlist-create' text='Add SOR' icon='write'/>
        </Dropdown.Menu>
        </Dropdown> */}
        {/* <Dropdown simple item text='Invoice'>
        <Dropdown.Menu>
        <Dropdown.Item as={NavLink} to='/dailymanagement/invoice' text='Query Invoice' icon='edit'/>
         <Dropdown.Item as={NavLink} to='/dailymanagement/invoice-create' text='Add Invoice' icon='write'/>
        </Dropdown.Menu>
        </Dropdown> */}
        <Menu.Item as={NavLink} to='/dailymanagement/invoice'>Invoice</Menu.Item>
        <Menu.Item as={NavLink} to='/dailymanagement/customer'>Customer</Menu.Item>
        {user && (
          <Menu.Item position="right" style={{ marginRight: '17%' }}>
            <Image avatar spaced='right' src={user.image || '/assets/user.png'} />
            <Dropdown pointing='top left' text={user.displayName}>
              <Dropdown.Menu>
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/profile`}
                text="My profile"
                icon="user"
              />
              <Dropdown.Item
                as={Link}
                to={`/employeeportal/certificate`}
                text="My certificate"
                icon="user"
              />
              <Dropdown.Item
                as={Link}
                to={"/employeeportal/assets"}
                text="My Assets"
                icon="user"
              />
                <Dropdown.Item onClick={logout} text='Logout' icon='power' />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Item>
        )}
    </Menu>
  );
};

export default observer(NavBarDaily);
